import React, { useEffect, useState } from "react";
import "../assets/css/shcolars.css";
import axios from "axios";
import configModule from "../../config";
import { FaAngleRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "./footer";

function ScholarshipPage() {
  const [categoryData, setCategoryData] = useState([]);
  const [scholarshipData, setScholarshipData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedScholarship, setSelectedScholarship] = useState(null);
  const config = configModule.config();
  const navigate = useNavigate();

  const createSlug = (title) => {
    return title
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  const fetchScholarshipData = async () => {
    try {
      const res = await axios.get(
        `${config.apiBaseUrl}/get-scholarshipdata`,
        {
          headers: {
            "x-api-key": config.apichKey,
          },
        }
      );

      setCategoryData(res.data.category || []);
      setScholarshipData(res.data.scholarship || []);
      setFilteredData(res.data.scholarship || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchScholarshipData();
  }, []);

  function decodeHTML(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  function cleanHTML(html) {
    return html.replace(/<\/?p>/g, "");
  }

  const handleCategoryChange = (e) => {
    const value = e.target.value;
    setSelectedCategory(value);

    if (!value) {
      setFilteredData(scholarshipData);
      return;
    }

    const filtered = scholarshipData.filter(
      (item) => String(item.course_category) === String(value)
    );

    setFilteredData(filtered);
  };

  return (
    <div className="scscholmain-container">
      {/* Banner */}
      <div className="cl-hero-banner" style={{ height: "92px" }}>
        <div className="cl-hero-pattern"></div>
        <div className="cl-hero-text">
          <h2>SCHOLARSHIPS</h2>
        </div>

        <span className="breadcrumb-st" > <span className="gotohome-st" onClick={() => navigate("/")} >Home</span> <FaAngleRight className="arrow_icon" /> <b>Scholarships</b> </span>
      </div>

      <div className="sccontainer-st">
        {/* Tabs */}
        <div className="d-flex justify-content-center mb-4">
          <div className="btn-group">
            <button className="btn btn-outline-secondary scbtn-outline-secondary">
              After +12
            </button>

            <button className="btn btn-outline-secondary scbtn-outline-secondary">
              After Graduation
            </button>
          </div>
        </div>

        {/* Category Dropdown */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-6">
            <label className="form-label text-center d-block fw-semibold">
              Select Category
            </label>

            <select
              className="form-select form-select-lg"
              value={selectedCategory}
              onChange={handleCategoryChange}
            >
              <option value="">Select Course Category</option>

              {categoryData.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.category}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="row-mainst">
          {filteredData.map((item) => (
            <div className="innerrow-main-st" key={item.id}>
              <div className="innerrow-mainst">
                <img
                  src={item.icon || null}
                  alt={item.title.substring(0, 20) + "..."}
                />

                <div className="">
                  <h5 className="headtitlesc-st">{item.title}</h5>
                  <div
                    className="overview-text"
                    dangerouslySetInnerHTML={{
                      __html: cleanHTML(decodeHTML((item.description?.length > 120
                        ? item.description.substring(0, 220) + "..."
                        : item.description) || ""))
                    }}
                  />
                </div>
              </div>
              
                <a
                  href={item.url}
                  target="_blank"
                  rel="noreferrer"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(
                      `/${item.id}/scholarship-details/${createSlug(item.title)}`,
                      {
                        state: {
                          scholarship: item,
                        },
                      }
                    )
                  }}
                  className="sccontact-usst"
                >
                  View Details
                </a>
                
            </div>
          ))}
        </div>

        {
          filteredData.length === 0 && (
            <div className="text-center py-5">
              <h5>No Scholarships Found</h5>
            </div>
          )
        }
      </div >

      <Footer />
    </div >
  );
}

export default ScholarshipPage;